<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-data-iterator
          :items="items"
          :loading="fetching"
          :items-per-page="items_per_page"
          :page.sync="current_page"
          :server-items-length="items_total"
          :single-expand="true"
          item-key="uuid"
        >
          <template v-slot:header>
            <v-card-actions>
              <form @submit.prevent="fetch">
                <v-text-field
                  label="Search"
                  solo
                  dense
                  flat
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  v-model="query"
                  @click:prepend-inner="fetch"
                  @click:clear="
                    () => {
                      query = null;
                      fetch();
                    }
                  "
                  :loading="fetching"
                ></v-text-field>
              </form>

              <v-select
                v-model="order_by"
                @change="fetch"
                solo
                dense
                flat
                hide-details
                :items="choices_order"
                item-text="text"
                item-value="value"
                label="Sort by"
              ></v-select>

              <v-btn
                icon
                depressed
                @click="
                  () => {
                    dir = dir == 'asc' ? 'desc' : 'asc';
                    fetch();
                  }
                "
              >
                <v-icon>{{ dir == 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
              </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
          </template>
          <template v-slot:no-data>
            <v-row align="center" justify="center">
              <div class="py-5">No data</div>
            </v-row>
          </template>
          <template v-slot:default="{ items, select, isSelected, expand, isExpanded }">
            <v-list>
              <template v-for="(item, index) in items">
                <message-item
                  @verify="verifyMessage"
                  @reject="rejectMessage"
                  v-bind="item"
                  :key="index"
                  @show="show"
                />
                <v-divider :key="index - 1000"></v-divider>
              </template>
            </v-list>
          </template>
        </v-data-iterator>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import MessageItem from "../../components/message/MessageItem";
export default {
  components: {
    "message-item": MessageItem
  },
  computed: {
    ...mapState("message", {
      fetching: "fetching",
      pagination: "pagination",
      instance: "instance",
      choices: "choices"
    }),

    ...mapGetters("message", {
      items: "items"
    }),
    ...mapFields("message", {
      query: "query.q",
      page: "query.page",
      order_by: "query.order_by",
      dir: "query.dir"
    }),
    choices_order: function() {
      return this.choices.order;
    },
    items_per_page: function() {
      return _.get(this.pagination, "per_page", 15);
    },
    last_page: function() {
      return _.get(this.pagination, "last_page", 1);
    },
    current_page: {
      get: function() {
        return _.get(this.pagination, "current_page", 1);
      },
      set: function(page) {
        this.page = page;
        this.fetch();
      }
    },
    items_total: {
      get: function() {
        return _.get(this.pagination, "total", 0);
      },
      set: function(value) {
        return;
      }
    }
  },
  methods: {
    ...mapActions("message", {
      fetch: "fetch",
      verify: "verify",
      reject: "reject"
    }),
    rejectMessage(uuid) {
      this.reject(uuid).then(() => this.fetch());
    },
    verifyMessage(uuid) {
      this.verify(uuid).then(() => this.fetch());
    },
    show(uuid = "1") {
      this.$router.push({ name: "message.show", params: { uuid } });
    }
  },

  mounted() {
    this.fetch();
  }
};
</script>

<style lang="scss" scoped></style>
